import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  Typography,
  Stack,
  Box
} from "@mui/material";
import React from "react";
import { useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { ElementsView } from "../Project/ElementsView/elementsView";

export const ElementsViewDialog = ({onOpen, onClose, canvasRef}) => {
  const [sortBy, setSortBy] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleSortBy = (field, direction) => {
    setSortBy(field);
    setSortDirection(direction);
  };

  const paperProps = useMemo(() => ({
    sx: {
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: '0px 12px 40px rgba(15, 23, 42, 0.18)'
    }
  }), []);

  return (
    <div>
      <Dialog open={onOpen} maxWidth="lg" fullWidth onClose={handleClose} PaperProps={paperProps}>
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 2.5,
            pr: 2,
            pl: 3
          }}
        >
          <Box>
            <Typography variant="h6" component="div">
              Nodes
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Review and manage all nodes in a sortable list.
            </Typography>
          </Box>
          <IconButton
            aria-label="Close nodes dialog"
            onClick={onClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent
          dividers
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.default'
          }}
        >
          <Stack spacing={2.5}>
            <ElementsView 
              onBulkDelete 
              canvasRef={canvasRef} 
              sortBy={sortBy}
              sortDirection={sortDirection}
              onSortBy={handleSortBy}
            />
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.paper',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            color="inherit"
            startIcon={<CloseIcon fontSize="small" />}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}